import React from "react";
import Icon from "../icons/Icons";
import "./WhyChooseTysonWorks.css";

const benefits = [
  {
    icon: "bolt",
    title: "Rapid Response",
    text: "Get same-day expert help when you need it. Our team is always ready to tackle your AWS challenges.",
  },
  {
    icon: "badgeDollar",
    title: "Cost Optimization",
    text: "Our clients save 40-60% on their AWS bills through our proven optimization techniques.",
  },
  {
    icon: "shield",
    title: "Security First",
    text: "Enterprise-grade security practices and compliance expertise (SOC2, HIPAA) built into everything we do.",
  },
  {
    icon: "trendUp",
    title: "Scale Ready",
    text: "Infrastructure that grows with you. From prototype to production to scale, we've got you covered.",
  },
  {
    icon: "users",
    title: "Dedicated Support",
    text: "Direct access to AWS experts who know your infrastructure inside and out.",
  },
  {
    icon: "layers",
    title: "Modern Stack",
    text: "Expertise in cutting-edge AWS services and best practices for maximum efficiency.",
  },
];

const WhyChooseTysonWorks = () => {
  return (
    <section id="why-us" className="section">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">why tysonworks</p>
          <h2 className="h2">Why fast-growing companies choose us</h2>
          <p className="lede">
            Get enterprise-grade AWS expertise without the enterprise price tag.
          </p>
        </div>
        <div className="benefits-grid">
          {benefits.map((benefit) => (
            <div className="benefit" key={benefit.title}>
              <div className="icon-tile">
                <Icon name={benefit.icon} />
              </div>
              <div>
                <h3 className="h3">{benefit.title}</h3>
                <p>{benefit.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseTysonWorks;
